import { Link, mergeStyles } from "@fluentui/react";

export default (props: { onClick: () => void; text: string }) => {
  return (
    <Link onClick={props.onClick} className={styles}>
      &#x3C; {props.text}
    </Link>
  );
};

const styles = mergeStyles({
  color: "inherit",
  textDecoration: "none!important",
});
